/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [leave-space-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 05.04.20, 18:41
 */

import React, {useState} from 'react';
import {useAuthorization} from "../../selectors";
import {useLanguage} from "../configuration/configuration";
import {Button} from "../navigation/buttons/nav-buttons";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {FormRow} from "../forms/manage-spaces/manage-space-form";
import {
    ONLY_MEMBERS_ACCESS,
    PRIVATE_ACCESS,
    PUBLIC_ACCESS,
    PUBLIC_BILLBOARD,
    SPACE_BILLBOARD
} from "../../actions/spaces";
import {getGenericVisibilityFromLocalStorage, saveGenericVisibilityToLocalStorage} from "../../actions/local-storage";
import {CloseIcon} from "../navigation/icons/nav-icons";

/**
 * just a helper component for gathering post information on access and visibility
 * updates are handled by the parent component
 */
const GenericPostVisibilityPopover = ({postId, access = '', onUpdate, onClose}) => {
    const [formData, setFormData] = useState(() => {
        const {visibility, access} = getGenericVisibilityFromLocalStorage();
        return {
            postId: postId,
            visibility: visibility,
            access: access,
    }});
    const [invalid, setInvalid] = useState(false);
    const {isAuthorized} = useAuthorization();
    const Lang = useLanguage();

    const handleOnChange = (event) => {
        setFormData({...formData, [event.target.name]: event.target.value});
    }

    const handleSubmit = (event) => {
        event.target.classList.add('was-validated');
        event.preventDefault();
        event.stopPropagation();

        if (!event.target.checkValidity()) {
            setInvalid(true);
            return;
        }
        setInvalid(false);

        saveGenericVisibilityToLocalStorage(formData.visibility, formData.access);
        onUpdate && onUpdate(formData);
        setTimeout(() => {
            onClose();
        }, 500);
    }

    if (!isAuthorized) return null;

    return <div className='px-2 py-1'>
        <NavigationRow>
            <NavigationGroup>
                <h4 className='clr-popover-search'>{Lang.visibility.popover.title}</h4>
            </NavigationGroup>
            <NavigationGroup>
                <button className='btn btn-outline-primary m-0 p-1' onClick={onClose}>
                    <CloseIcon big className='clr-popover-search'/>
                </button>
            </NavigationGroup>
        </NavigationRow>


        <form noValidate className={`needs-validation ${invalid ? 'form-invalid' : ''} text-start`}
              onSubmit={handleSubmit}>

            <label className="form-check-label"
                   htmlFor="publicAccessId">{Lang.visibility.popover.publicize}</label>
            <FormRow className="form-check-label ">
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="visibility"
                           checked={formData.visibility === PUBLIC_BILLBOARD}
                           onChange={handleOnChange}
                           id="publicAccessId" value={PUBLIC_BILLBOARD} required/>
                    <label className="form-check-label"
                           htmlFor="publicAccessId">{Lang.visibility.popover.publicBillboard}</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="visibility"
                           checked={formData.visibility === SPACE_BILLBOARD}
                           onChange={handleOnChange}
                           id="privateId" value={SPACE_BILLBOARD}/>
                    <label className="form-check-label"
                           htmlFor="privateId">{Lang.visibility.popover.spaceBillboard}</label>
                </div>
            </FormRow>

            <label className="form-check-label"
                   htmlFor="publicAccessId">{Lang.visibility.popover.postAccess}</label>
            <FormRow className="form-check-label ">
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="access"
                           checked={formData.access === PUBLIC_ACCESS}
                           onChange={handleOnChange}
                           id="publicAccessId" value={PUBLIC_ACCESS} required/>
                    <label className="form-check-label"
                           htmlFor="publicAccessId">{Lang.updateSpace.access.public}</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="access"
                           checked={formData.access === PRIVATE_ACCESS}
                           onChange={handleOnChange}
                           id="privateId" value={PRIVATE_ACCESS}/>
                    <label className="form-check-label"
                           htmlFor="privateId">{Lang.updateSpace.access.private}</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="access"
                           checked={formData.access === ONLY_MEMBERS_ACCESS}
                           onChange={handleOnChange}
                           id="restrictedId" value={ONLY_MEMBERS_ACCESS}/>
                    <label className="form-check-label"
                           htmlFor="restrictedId">{Lang.updateSpace.access.onlyMembers}</label>
                </div>
            </FormRow>

            <FormRow className='mt-2 mb-2'>
                <Button block
                        type="submit">{Lang.visibility.popover.save}</Button>
            </FormRow>

        </form>
    </div>
};

export default GenericPostVisibilityPopover;